<template>
  <b-card no-body class="border-0">
    <b-card-body>
      <b-row align-content="center">
        <b-col cols="6">
          <div class="h4 text-muted">
            ชื่องาน/ชื่อลูกค้า :
          </div>
        </b-col>
        <b-col cols="6">
          <div class="d-flex flex-column text-right">
            <span class="h4 mb-0">{{ job.job_name }}</span>
            <span class="h5 mb-0 text-muted">{{ job.customer ? job.customer.shop_name : '-' }}</span>
          </div>
        </b-col>
      </b-row>
      <hr class="my-3" />
      <b-row>
        <b-col cols="6" class="border-right">
          <div class="h4 text-muted">เวลาเริ่ม-สิ้นสุดงาน :</div>
          <span>{{ `${job.started_datetime} น.` }}</span>
        </b-col>
        <b-col cols="6">
          <div class="h4 text-muted">ระยะทาง :</div>
          <span>{{ `${job.distance} (กม.)` }}</span>
        </b-col>
      </b-row>
      <hr class="my-3" />
      <b-row align-content="center">
        <b-col cols="6" class="d-flex align-items-center">
          <div class="h4 text-muted">
            ราคาน้ำมัน :
          </div>
        </b-col>
        <b-col cols="6">
          <div class="d-flex flex-column text-right">
            <span class="h4 mb-0">{{ `${job.oil_price} บาท` }}</span>
            <span class="h6 mb-0 text-muted">{{ `(${job.created_date})` }}</span>
          </div>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
export default {
  props: {
    job: {
      type: Object,
    },
  },
};
</script>
